// import isEmpty from 'lodash.isempty';
import Swiper, { Navigation, Pagination, Autoplay, A11y } from 'swiper';
// import { closeModal, createModal, openModal } from '3-components/Modal/Modal';
// import ChevronLeft from '../../assets/icons/chevron-left.svg';
// import ChevronRight from '../../assets/icons/chevron-right.svg';

Swiper.use([Navigation, Pagination, Autoplay, A11y]);

interface TabProps {
    el: HTMLElement;
}

const ACTIVE_CLASS = 'is-active';

const Tab = ({ el }: TabProps): void => {
    const cardContainer = el.querySelector('.tab-item-container');
    const items = el.querySelectorAll('.tab-item-container > div');
    // const isMoreThanOneSlide = items.length > 1;
    const slideNumberClass = `slides-${items.length}`;
    const sliderContainer = el.querySelector('.tab-scroll');
    // const headerContainer = el.querySelector('.tab-header');
    const contentItems = el.querySelectorAll('.tab-item .tab-content-item');

    if (!cardContainer || !sliderContainer || !contentItems) {
        return;
    }

    el.classList.add(slideNumberClass);

    // const id = uuid();

    const constructElement = (): { tabItems: NodeListOf<Element>; itemButtons: NodeListOf<Element> } => {
        cardContainer.classList.add('swiper-wrapper');

        // wrap each item with div.swiper-slide
        items.forEach(item => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('swiper-slide');
            item.parentNode?.insertBefore(wrapper, item);
            wrapper.appendChild(item);
        });

        const sliderEl = `<div class="swiper-container">
            ${cardContainer.outerHTML}
        </div>
        `;

        sliderContainer.innerHTML = sliderEl;

        return {
            tabItems: sliderContainer.querySelectorAll('.tab-item'),
            itemButtons: sliderContainer.querySelectorAll('.tab-item-btn'),
        };
    };

    const constructContent = (): { tabContentItems: NodeListOf<Element> } => {
        const contentContainer = document.createElement('div');
        contentContainer.classList.add('tab-content-container');

        contentItems.forEach(item => {
            contentContainer.appendChild(item);
        });

        const contentEl = `<div class="tab-content">
                ${contentContainer.outerHTML}
            </div>
        `;

        el.insertAdjacentHTML('beforeend', contentEl);

        return { tabContentItems: el.querySelectorAll('.tab-content-container .tab-content-item') };
    };

    const { tabItems, itemButtons } = constructElement();
    const { tabContentItems } = constructContent();

    const swiperContainer: HTMLElement | null = el.querySelector('.swiper-container') as HTMLDivElement;

    const cardSwiper = new Swiper(swiperContainer, {
        init: false,
        slidesPerView: 'auto' as number | 'auto',
        freeMode: true,
        threshold: 10,
        slidesPerGroup: 2,
        touchReleaseOnEdges: true,
        centerInsufficientSlides: true,
    });

    cardSwiper.init();

    const removeItemsActiveClass = (): void => {
        tabItems.forEach(tabItem => {
            tabItem.classList.remove(ACTIVE_CLASS);
        });

        tabContentItems.forEach(tabContentItem => {
            tabContentItem.classList.remove(ACTIVE_CLASS);
        });
    };

    itemButtons.forEach((itemButton, index) => {
        // initial check on active tab
        if (itemButton.parentElement?.classList.contains('is-active')) {
            tabContentItems[index].classList.add(ACTIVE_CLASS);
        }

        // add event listener to set active tab
        itemButton.addEventListener('click', () => {
            removeItemsActiveClass();
            itemButton.parentElement?.classList.add(ACTIVE_CLASS);
            tabContentItems[index].classList.add(ACTIVE_CLASS);
        });
    });

    // Just to ensure at the correct position after initialisation (sometime not on center)
    setTimeout(() => {
        cardSwiper.update();
    }, 500);
};

export default Tab;
